import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

import { fadeUpAnimation } from "../index.styles";

const sectionFaq = styled.section<{ backgroundColor: string }>`
  padding: 80px 0 100px;
  background-color: ${({ backgroundColor }) => backgroundColor};

  ${mobile(css`
    padding: 48px 16px;
  `)}
`;

const container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  ${mobile(css`
    align-items: flex-start;
  `)}

  h3 {
    ${mobile(css`
      padding-left: 8px;
    `)};
  }

  ${fadeUpAnimation}
`;

const accordionWrapper = styled.div<{ count: number }>`
  padding: 0 120px;

  ${mobile(css`
    padding: 0;
  `)}

  .accordion-item {
    ${({ count }) =>
      Array.from(
        { length: count },
        (_, index) => `
      &:nth-child(${index + 1}) {
        animation-delay: ${(0.2 * index + 0.4).toFixed(1)}s;
      }
    `
      ).join("\n")}
  }
`;

const accordionDesc = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const accordionDescSub = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  em {
    ${setFontStyle("SubHead2")};
    color: ${COLOR.point_400};
  }

  dl {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: repeat(2, auto);
    gap: 4px;
  }
`;

export default {
  sectionFaq,
  container,
  accordionWrapper,
  accordionDesc,
  accordionDescSub,
};
